import { MainExercise } from "@domain/exercise/exercise";
import styled from "@emotion/styled";
import { Stepper } from "@ui/components/buttons/stepper";
import { ExerciseDragAndDropContext } from "@ui/pages/program-builder/drag-drop/program-builder-drag-drop-context";
import { ExerciseOptions } from "@ui/pages/program-builder/library/exercise-options";
import { isNil } from "@utils/assert";
import React, { useContext, useMemo } from "react";

export const EXERCISE_FOOTER_HEIGHT = 48;

export const ExerciseFooterOptions: React.FC<{
	exercise: MainExercise;
	onlyAllowPreview?: boolean;
	shouldDisplayHalo?: boolean;
}> = ({ exercise, onlyAllowPreview, shouldDisplayHalo }) => {
	const dragAndDropContext = useContext(ExerciseDragAndDropContext);

	const exerciseIndices = useMemo(
		() => dragAndDropContext?.programEditor.getExerciseIndex(exercise.draggableId),
		[exercise.draggableId, dragAndDropContext?.programEditor],
	);

	if (isNil(dragAndDropContext) || isNil(exerciseIndices)) return null;

	const handleMoveUp = () => {
		dragAndDropContext.programEditor.reorderSessionExercises(
			exerciseIndices.sessionIndex,
			exerciseIndices.exerciseIndex,
			exerciseIndices.exerciseIndex - 1,
		);
	};

	const handleMoveDown = () => {
		dragAndDropContext.programEditor.reorderSessionExercises(
			exerciseIndices.sessionIndex,
			exerciseIndices.exerciseIndex,
			exerciseIndices.exerciseIndex + 1,
		);
	};

	return (
		<Container>
			<StyledStepper
				onMoveUp={handleMoveUp}
				onMoveDown={handleMoveDown}
				min={0}
				max={dragAndDropContext.programEditor.getExerciseCountInSession(exerciseIndices.sessionIndex) - 1}
				value={exerciseIndices.exerciseIndex}
			/>
			<div>
				<ExerciseOptions
					exercise={exercise}
					onlyAllowPreview={onlyAllowPreview}
					shouldDisplayHalo={shouldDisplayHalo}
				/>
			</div>
		</Container>
	);
};

const Container = styled.div`
	height: ${EXERCISE_FOOTER_HEIGHT}px;
	display: flex;
	justify-content: space-between;
	margin: -4px 4px -8px;

	> svg {
		cursor: pointer;
	}
`;

const StyledStepper = styled(Stepper)`
	margin-left: 12px;
`;